import React from "react";
import "./Signup.css";
import logo from "./Media/vipps.png";
import searchpng from "./Media/vippssearch.PNG";
import codepng from "./Media/vippscode.PNG";
import vippsentrance from "./Media/vippsentrance.PNG";
import commentpng from "./Media/addcomment.PNG";

//This is just an info page that displays a tutorial on how to pay

export class PaymentInfo extends React.Component {
  constructor() {
    super();

    this.showGDPRModal = this.showGDPRModal.bind(this);
    this.closeGDPRModal = this.closeGDPRModal.bind(this);

    this.state = {
      promptGDPRModal: false,

      visibility: true
    };
  }

  handleVisibilityChange = isVisible => {
    this.setState({ visibility: isVisible });
  };

  showGDPRModal(e) {
    //We show a modal that explains what we store about the user

    this.setState({ promptGDPRModal: true });
  }

  closeGDPRModal() {
    this.setState({ promptGDPRModal: false });
  }

  render() {
    return (
      <div className="Signup">
        <h1>Hvordan betaler jeg?</h1>
        <div className="infoCard">
          <br></br>
          <div className="col-center darkCardBackground">
            <h4>Vi godtar kun betaling via Vipps</h4>
            <img className="vippsinput" src={logo} alt="logo" />
          </div>
          <br></br>
          <h4>
            Etter du er ferdig med å melde deg på, og har fått ordrebekreftelsen
            tilsendt på mail følger du denne guiden:
          </h4>
          <br />
          <p>Betalingen må være gjennomført innen 3 dager fra påmelding.</p>
          <br />
          <p>
            Åpne Vipps-appen og trykk "send" <br />I søkefeltet, søk på
            "gamerlan".
          </p>
          <center>
            <img className="vippsinput" src={searchpng} alt="searchpng" />
          </center>
          <p>
            <br />
            Du skal nå se GAMERLAN med nummer #64923. Trykk på denne.
            <br />
            Legg inn totalsummen du skal betale.
          </p>
          <center>
            <img
              className="vippsinput"
              src={vippsentrance}
              alt="vippsentrance"
            />
          </center>
          <br />
          <p>
            Eposten du mottok da du reserverte inneholder en oversikt over det
            du skal betale.
            <br />
            Sjekk at totalprisen stemmer med det som er oppgitt i eposten.
          </p>
          <br />
          <p>
            Veldig viktig: Rett under summen legger du til kommentar.
          </p>
          <center>
            <img className="vippsinput" src={commentpng} alt="commentpng" />
          </center>
          <br />

          <p>
            Koden du mottok på mail som består av seks tegn må skrives inn her.
            F.eks. "ABC123".
          </p>
          {false && <center>
            <img className="vippsinput" src={codepng} alt="codepng" />
          </center> }
          <br />
          <p>Gjennomfør betalingen.</p>
          <p>
            Om noe er uklart, ta kontakt med oss på post@gamerlan.no, eller på
            Facebook.
          </p>
        </div>
      </div>
    );
  }
}

export default PaymentInfo;



// WEBPACK FOOTER //
// ./src/Components/Signup/PaymentInfo.js